<!--
  Private Pinterest-pin gallery. A thin shell that renders one
  <app-pinterest-card> per theme; the card owns the full pin design.

  With ?only=<product-key> only that theme's pin is rendered (capture mode).
-->
<ng-container *ngFor="let line of themes; trackBy: trackByLineKey">
  <ng-container *ngFor="let product of line.products; trackBy: trackByProductKey">
    <app-pinterest-card *ngIf="product.key !== 'all-in-one' && (!onlyKey || product.key === onlyKey)"
                        [product]="product"
                        [productLine]="line"></app-pinterest-card>
  </ng-container>
</ng-container>
